import { render, staticRenderFns } from "./tzggDetail.vue?vue&type=template&id=39660892"
import script from "./tzggDetail.vue?vue&type=script&lang=js"
export * from "./tzggDetail.vue?vue&type=script&lang=js"
import style0 from "./tzggDetail.vue?vue&type=style&index=0&id=39660892&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports